import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'

export interface TextMark {
  type: 'bold' | 'italic' | 'underline'
}

export interface TextNode {
  nodeType: 'text'
  value: string
  marks: TextMark[]
  data: Record<string, unknown>
}

export interface ParagraphNode {
  nodeType: 'paragraph'
  data: Record<string, unknown>
  content: TextNode[]
}

export interface ListItemNode {
  nodeType: 'list-item'
  data: Record<string, unknown>
  content: ParagraphNode[]
}

export interface UnorderedListNode {
  nodeType: 'unordered-list'
  data: Record<string, unknown>
  content: ListItemNode[]
}

export type ContentNode = ParagraphNode | UnorderedListNode

interface BlogBody {
  nodeType: 'document'
  data: Record<string, unknown>
  content: ContentNode[]
}

export interface BlogEntry {
  fields: {
    title: string
    body: BlogBody
  }
  contentTypeId: 'blogPost'
}

export default class BlogPostRoute extends Route {
  @service contentfulClient!: ContentfulClientService
  model(params: { blog_id: string }) {
    return this.contentfulClient.requestEntry<BlogEntry>(params.blog_id)
  }
}
